import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Map, Control, ControlPosition, DomUtil} from 'leaflet';
import {MapService} from '../../services/map.service';

@Component({
  selector: 'app-map-controls',
  templateUrl: './map-controls.component.html',
  styleUrls: ['./map-controls.component.scss']
})
export class MapControlsComponent implements OnInit, OnDestroy {

  private map: Map;
  public custom: Control;
  @Input() position: ControlPosition;

  constructor(private mapService: MapService) {
  }

  ngOnInit() {
    this.mapService.mapReady$.subscribe(map => {
      this.map = map;
      this.addControl();
    });
  }

  ngOnDestroy() {
    this.map.removeControl(this.custom);
  }

  private addControl() {
    const custom = Control.extend({
      onAdd(m: Map) {
        return DomUtil.get('custom');
      },
      onRemove(m: Map) {
      }
    });
    this.custom = new custom({
      position: this.position
    }).addTo(this.map);
  }

  test($event: MouseEvent) {
    alert('HEy');
  }
}
